/**
 * Big Apple: show the spec table for the selected variant (blocks/bigapple-specs.liquid renders one per variant).
 *
 * Horizon keeps ?variant= in the URL in step with the variant picker but does not re-render this section, so
 * after any change on the page we re-read the URL and show the matching table. Listening for the native
 * `change` event at the document keeps this independent of Horizon's internal event names; popstate covers
 * back/forward. If the URL names no variant (first load), the server already marked the right table visible.
 */
class BigappleSpecs extends HTMLElement {
  connectedCallback() {
    this.sync = () => {
      const id = new URL(window.location.href).searchParams.get('variant');
      if (!id) return;
      const tables = this.querySelectorAll('[data-variant-id]');
      if (![...tables].some((t) => t.dataset.variantId === id)) return;
      for (const t of tables) t.hidden = t.dataset.variantId !== id;
    };
    this.onChange = () => setTimeout(this.sync, 50);
    document.addEventListener('change', this.onChange);
    window.addEventListener('popstate', this.sync);
    this.sync();
  }

  disconnectedCallback() {
    document.removeEventListener('change', this.onChange);
    window.removeEventListener('popstate', this.sync);
  }
}

if (!customElements.get('bigapple-specs')) customElements.define('bigapple-specs', BigappleSpecs);
